import {
    NavLink,
    useParams
} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';

export const IndexPageNavigation = () => {

    const {id: organizationId} = useParams()
    if (!organizationId) {
        throw new Error('Organization id is required');
    }


    const breadcrumbs = [
            {
                title: 'Home',
                href: '/dashboard',
            }, {
                title: 'Organizations',
                href: '/organizations',
            }, {
                title: 'Organization',
                href: `/organizations/${organizationId}`,
            }, {
                title: 'Organization Accounts'
            }
        ].map((item, index) => (
            <Box key={index}> {
                item
                    .href ?
                    <NavLink to={item.href}>{item.title}</NavLink> : item.title
            }
            </Box>
        ))
    ;
    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};

